<template>
  <li class="list-group-item d-flex align-items-center">
    <div v-if="node.type === 'folder'">
      📁 {{ node.name }}
      <ul class="list-group mt-2">
        <tree-node 
          v-for="child in node.children" 
          :key="child.name" 
          :node="child" 
          @action="handleAction">
        </tree-node>
      </ul>
    </div>
    <div v-else class="d-flex align-items-center">
      📄 {{ node.name }}
      <span v-if="node.tokentype === 'OneTimeFile'" class="expiration-date ms-3">(One-Time File)</span>
      <span v-else-if="node.expirationDate" class="expiration-date ms-3">
        (Expires: {{ formatExpiration(node.expirationDate) }})
      </span>

      <!-- Кнопки действий -->
      <button @click="handleDownload" class="btn btn-sm btn-success ms-3">
        <i class="fas fa-download"></i>
      </button>
      <button @click="handleDelete" class="btn btn-sm btn-danger ms-2">
        <i class="fas fa-trash"></i>
      </button>
      <button v-if="node.type === 'file'" @click="handleCopyLink" class="btn btn-sm btn-info ms-2">
        <i class="fas fa-copy"></i>
      </button>
    </div>
  </li>
</template>

<script>
export default {
  props: ['node'],
  methods: {
    handleAction(action, node) {
      // Передаем node в качестве параметра для гарантии, что это файл, а не папка
      this.$emit('action', action, node);
    },
    handleDownload() {
      // Отправляем событие для загрузки конкретного узла (файла)
      this.handleAction('download', this.node);
    },
    handleDelete() {
      // Отправляем событие для удаления конкретного узла (файла)
      this.handleAction('delete', this.node);
    },
    handleCopyLink() {
      // Копирование ссылки инициируется только для файлов
      if (this.node.type === 'file') {
        this.handleAction('copy-link', this.node);
      }
    },
    formatExpiration(expirationDate) {
      const date = new Date(expirationDate);
      return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    },
  },
};
</script>





<style scoped>
/* Добавляем стили для отступов */
.expiration-date {
  font-size: 0.9rem;
  color: gray;
  margin-left: 10px;
}

/* Отступы для кнопок */
.btn {
  margin-left: 10px;
}

/* Все иконки внутри кнопок будут белыми */
.btn i {
  color: white;
}
</style>
